import React from 'react';
import { createPortal } from 'react-dom';
import { FiX } from 'react-icons/fi';

const SizeChartModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[99999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition-colors">
          <FiX size={24} />
        </button>
        <h2 className="text-xl font-medium text-center mb-5" style={{ color: 'var(--text-color)' }}>Size Chart</h2>
        
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-200 text-sm">
            <thead style={{ backgroundColor: 'var(--primary-color)', color: 'white' }}>
              <tr>
                <th className="p-2 text-center border-r border-white/20">EU</th>
                <th className="p-2 text-center border-r border-white/20">UK</th>
                <th className="p-2 text-center border-r border-white/20">US</th>
                <th className="p-2 text-center border-r border-white/20">CM</th>
              </tr>
            </thead>
            <tbody className="text-center text-gray-700">
              <tr className="border-b border-gray-200"><td className="p-2">35</td><td className="p-2">3</td><td className="p-2">5.5</td><td className="p-2">22.9</td></tr>
              <tr className="border-b border-gray-200"><td className="p-2">36</td><td className="p-2">3.5</td><td className="p-2">6</td><td className="p-2">23.3</td></tr>
              <tr className="border-b border-gray-200"><td className="p-2">37</td><td className="p-2">4</td><td className="p-2">6.5</td><td className="p-2">23.8</td></tr>
              <tr className="border-b border-gray-200"><td className="p-2">38</td><td className="p-2">4.5</td><td className="p-2">7</td><td className="p-2">24.1</td></tr>
              <tr className="border-b border-gray-200"><td className="p-2">39</td><td className="p-2">5</td><td className="p-2">7.5</td><td className="p-2">24.8</td></tr>
              <tr className="border-b border-gray-200"><td className="p-2">40</td><td className="p-2">6</td><td className="p-2">8.5</td><td className="p-2">25.4</td></tr>
              <tr className="border-b border-gray-200"><td className="p-2">41</td><td className="p-2">6.5</td><td className="p-2">9</td><td className="p-2">25.9</td></tr>
              <tr className="border-b border-gray-200"><td className="p-2">42</td><td className="p-2">7</td><td className="p-2">9.5</td><td className="p-2">26.3</td></tr>
            </tbody>
          </table>
        </div>

        <p className="text-xs text-gray-500 mt-4 text-center">Sizing may vary slightly between brands. Please check product details.</p>
      </div>
    </div>,
    document.body
  );
};

export default SizeChartModal;